import ThankYouPage from "../../pages/ThankYouPage/ThankYouPage";

const INITIAL_STATE = {
    reserve:[],
    preload:true,
    booking:[],
    thankyoupage:false,
    feDeExPas:''
}; 
export default (state= INITIAL_STATE, action) => {
    switch (action.type) {
      
        case "GET_CHECKOUT":
        //fecha maxima para validacion de pasaporte 
            if (action.payload.bookingItems[0].leg && action.payload.bookingItems[0].leg.arrival) {
                const arr = [];
                action.payload.bookingItems.map((item, index) => {
                    let arrival = new Date(item.leg.arrival);
                    arrival.setDate(arrival.getDate() + 2);
                    arr.push(arrival.getFullYear() + '-' + ("0" + (arrival.getMonth() + 1)).slice(-2) + '-' + ("0" + arrival.getDate() ).slice(-2))
                })
    
                let arrayFechas = arr.map((fechaActual) => new Date(fechaActual) );
                var max = new Date(Math.max.apply(null,arrayFechas));
                var feDeExPas =  max.getFullYear() + '/' + ("0" + (max.getMonth() + 1)).slice(-2) + '/' + ("0" + max.getDate()).slice(-2)
            } else {
                var feDeExPas =  (action.payload.bookingItems[0].validityPeriod ? action.payload.bookingItems[0].validityPeriod.endDate : action.payload.bookingItems[0].activationPeriod.endDate);
                var feDeExPas =  feDeExPas.replace(/-/g, "/");
            }

            return {...state, reserve:action.payload,feDeExPas:feDeExPas,preload:false}
            
        case "GET_BOOKING":
            return {...state, booking:action.payload,preload:false,thankyoupage:true}

        default:
            return state;
    }
    
}



